import {
  TEXT_REGEX,
  DOC_NUMBER_REGEX,
  CIF_REGEX,
  EMAIL_REGEX,
  validateMobilePhone,
  validDocNumber,
  validEmptyText,
  customValidEmail,
} from '@/utils/validators';

export const PERSONAL_DATA_VIEWS = {
  BAF: 'baf',
  LM: 'lm',
  ADDITIONAL_FIBER: 'aditional_fiber',
  MANUAL: 'manual',
};

export const AU_IDENTIFICATION_TYPES = {
  AU_IDENTIFICATION_TYPE_CIF: {
    label: 'CIF con representante legal',
    value: 'AU_IDENTIFICATION_TYPE_CIF',
  },
  AU_IDENTIFICATION_TYPE_NIF: {
    label: 'NIF autónomos por cuenta propia',
    value: 'AU_IDENTIFICATION_TYPE_NIF',
  },
};
export const PERSONAL_DATA = {
  ID: 'personalData',
  TITLE: 'Datos personales',
  TITLE_CONTACT_DATA: 'Datos de contacto',
  TITLE_AU: 'Datos del titular',
  DOC_NUMBER: {
    NAME: 'docNumber',
    ID: 'docNumber',
    LABEL: 'DNI o NIE',
    LABEL_AU: 'DNI o NIE representante legal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        DOC_NUMBER_FORMAT: {
          value: DOC_NUMBER_REGEX,
          message: 'El formato introducido no es válido',
        },
      },
      VALIDATE: {
        DOC_NUMBER_FORMAT: {
          checkFunc: validDocNumber,
          message: 'El formato introducido no es válido',
        },
      },
    },
  },
  NAME: {
    NAME: 'name',
    ID: 'name',
    LABEL: 'Nombre',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        NAME_FORMAT: {
          value: TEXT_REGEX,
          message: 'Nombre no válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  LAST_NAME: {
    NAME: 'lastName',
    ID: 'lastName',
    LABEL: 'Primer apellido',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        LAST_NAME_FORMAT: {
          value: TEXT_REGEX,
          message: 'Primer apellido no válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  SECOND_SURNAME: {
    NAME: 'secondSurname',
    ID: 'secondSurname',
    LABEL: 'Segundo apellido',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        SECOND_SURNAME_FORMAT: {
          value: TEXT_REGEX,
          message: 'Segundo apellido no válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  EMAIL: {
    NAME: 'email',
    ID: 'email',
    LABEL: 'Email de contacto',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        EMAIL_FORMAT: {
          value: EMAIL_REGEX,
          message: 'Email no válido. Ejemplo válido: prueba@prueba.com',
        },
      },
      VALIDATE: {
        EMAIL_DOMAIN: {
          checkFunc: customValidEmail,
          message: 'Email no válido. Ejemplo válido: prueba@prueba.com',
        },
      },
    },
  },
  CONTACT_PHONE: {
    NAME: 'contactPhone',
    ID: 'contactPhone',
    LABEL: 'Móvil de contacto',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        CONTACT_PHONE_FORMAT: {
          checkFunc: validateMobilePhone,
          message:
            'El formato introducido no es válido, deben ser 9 dígitos numéricos.',
        },
      },
    },
    INFO: 'Te enviaremos un SMS para confirmar el pedido',
    MASK: { maxLength: 9, separationLength: 3, separator: ' ' },
  },
  MODAL_CONTACT_PHONE: {
    NAME: 'modalContactPhone',
    ID: 'modalContactPhone',
    LABEL: 'Móvil de contacto',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      VALIDATE: {
        CONTACT_PHONE_FORMAT: {
          checkFunc: validateMobilePhone,
          message:
            'El formato introducido no es válido, deben ser 9 dígitos numéricos.',
        },
      },
    },
    INFO: 'Te enviaremos un SMS para confirmar el pedido',
    MASK: { maxLength: 9, separationLength: 3, separator: ' ' },
  },
  AU_IDENTIFICATION_TYPE: {
    ID: 'auIdentificationType',
    NAME: 'auIdentificationType',
    LABEL: '¿Como te vas a identificar',
    RULES: {
      REQUIRED: 'Campo obligatorio',
    },
    OPTIONS: [
      {
        value: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_CIF.value,
        label: {
          text: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_CIF.label,
        },
      },
      {
        value: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_NIF.value,
        label: {
          text: AU_IDENTIFICATION_TYPES.AU_IDENTIFICATION_TYPE_NIF.label,
        },
      },
    ],
  },
  FULL_NAME: {
    ID: 'fullName',
    NAME: 'fullName',
    LABEL: 'Nombre y apellidos representante legal',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        NAME_FORMAT: {
          value: TEXT_REGEX,
          message: 'El formato introducido no es válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  COMPANY_NAME: {
    ID: 'CompanyName',
    NAME: 'CompanyName',
    LABEL: 'Razon social',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        COMPANY_NAME: {
          value: TEXT_REGEX,
          message: 'El formato introducido no es válido',
        },
      },
      VALIDATE: {
        EMPTY_TEXT: {
          checkFunc: validEmptyText,
          message: 'Campo obligatorio',
        },
      },
    },
  },
  CIF: {
    ID: 'cif',
    NAME: 'cif',
    LABEL: 'CIF',
    RULES: {
      REQUIRED: 'Campo obligatorio',
      PATTERN: {
        CIF_FORMAT: {
          value: CIF_REGEX,
          message: 'El formato introducido no es válido',
        },
      },
    },
  },
};
